// dataSearchesSlice.js

import { createSlice } from "@reduxjs/toolkit";
import { searchesApi } from "./searchesApi";

/* -- initial state ------------------------------------------------------- */
const initialState = {
    status: "idle", // idle | loading | partiallyLoaded | loaded | error
    data: [],
    hotelID: null,
    error: null,
};

/* -- slice --------------------------------------------------------------- */
const slice = createSlice({
    name: "dataSearches",
    initialState,
    reducers: {
        loading_Searches: (state, action) => {
            const { hotelID } = action.payload;
            state.data = [];
            state.hotelID = hotelID;
            state.status = "loading";
        },
        partiallyLoad_Searches: (state, action) => {
            const { data, hotelID } = action.payload;

            state.data = data;
            state.hotelID = hotelID;
            state.status = "partiallyLoaded";
        },
        load_Searches: (state, action) => {
            const { data, hotelID } = action.payload;

            state.data = data;
            state.hotelID = hotelID;
            state.status = "loaded";
        },
    },
    extraReducers: (builder) =>
        builder
            /* pending ---------------------------------------------------- */
            .addMatcher(
                searchesApi.endpoints.getSearches.matchPending,
                (state, { meta }) => {
                    // Queries can update when we are in a different hotel so dont change the state within the matchers/resolution of a query
                }
            )
            /* fulfilled --------------------------------------------------- */
            .addMatcher(
                searchesApi.endpoints.getSearches.matchFulfilled,
                (state, { meta, payload }) => {
                    // Queries can update when we are in a different hotel so dont change the state within the matchers/resolution of a query
                }
            )
            /* rejected ---------------------------------------------------- */
            .addMatcher(
                searchesApi.endpoints.getSearches.matchRejected,
                (state, { error }) => {
                    // Queries can update when we are in a different hotel so dont change the state within the matchers/resolution of a query
                    // state.status = "error";
                    // state.error = error;
                    console.log("Matcher Rejected", { state });
                }
            ),
});

export default slice.reducer;
export const { load_Searches, partiallyLoad_Searches, loading_Searches } =
    slice.actions;
